define('glu/grid/multiColumnSort/manageDialogLayout',['require','../../layout','../../dialog','../../util','../../locale','../../listBuilder/listBuilderLayout','hbs!./manageDialogLayout.hbs'],function(require) {
    'use strict';

    var Layout = require('../../layout'),
        dialog = require('../../dialog'),
        util = require('../../util'),
        locale = require('../../locale'),
        ListBuilder = require('../../listBuilder/listBuilderLayout'),
        tmpl = require('hbs!./manageDialogLayout.hbs');

    return Layout.extend({
        template: tmpl,
        modalClass: 'manage-multi-sort-dialog',
        regions: {
            listBuilder: '.region-list-builder'
        },
        initialize: function() {
            this.sortedColumnsCollection = this.options.sortedColumnsCollection;
            this.selectedColumnsCollection = this.selectedColumnsCollection || this.options.targetCollection;
        },
        onRender: function() {
            this.tempSource = this.sortedColumnsCollection.clone();
            this.tempTarget = this.selectedColumnsCollection.clone();
            this.listBuilder.show(this.createListBuilder());
        },
        onShow: function() {
            this.toggleApplyButton();
        },
        onClose: function() {
            if (!this.manage) {
                this.options.view.toggleSwitch(false);
            }
        },
        dialogTitle: function() {
            return this.options.dialogTitle;
        },
        dialogButtons: [{
            text: locale.get('apply'),
            className: 'btn-primary',
            callback: 'applySort'
        }, {
            text: locale.get('cancel'),
            className: 'btn-default',
            callback: function() {
                dialog.close();
            }
        }],
        createListBuilder: function() {
            var listBuilderOptions = util.extend({
                    dataPersist: true,
                    sourceCollection: this.tempSource,
                    targetCollection: this.tempTarget
                }, this.options.listBuilderOptions),
                listBuilder = new ListBuilder(listBuilderOptions);

            this.listenTo(listBuilder, 'targetListUpdated', this.toggleApplyButton);

            return listBuilder;
        },
        setManage: function(manage) {
            this.manage = manage;
        },
        toggleApplyButton: function() {
            this.$el.parent().next('.modal-footer').find('.btn-primary').prop('disabled', (!this.tempTarget.length && !this.manage));
        },
        applySort: function() {
            if (this.tempTarget.length > 0) {
                this.sortedColumnsCollection = this.tempSource;
                this.selectedColumnsCollection = this.tempTarget;
                this.options.view.applyMultiColumnSort(this.tempTarget.clone());
                this.setManage(true);
            } else {
                this.setManage(false);
            }

            dialog.close();
        }
    });
});

